import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ConfigurationService } from '@sondermind/configuration';
import { HttpService } from '@sondermind/http';
import { IAPIListRequestOptions, IAPIListResponse } from '@sondermind/utilities/models-http';
import { ILocationApiResponse } from '@sondermind/utilities/models-location';

export function locationHttpFactory(
  http: HttpService,
  configurationService: ConfigurationService): LocationHttpService {
  return new LocationHttpService(http, configurationService);
}

@Injectable({
  providedIn: 'root'
})
export class LocationHttpService {
  constructor(
    private http: HttpService,
    private configurationService: ConfigurationService,
  ) {}

  load(opts: Partial<IAPIListRequestOptions> = {}): Observable<IAPIListResponse<ILocationApiResponse>> {
    const url = `${this.configurationService.env.svcBase}/locations`;
    const params = this.http.generateListParams(opts);

    return this.http
      .get<IAPIListResponse<ILocationApiResponse>>(url, params)
      .pipe(
        map((resp) => resp),
        this.http.handleHttpError(opts.error)
      );
  }
}
